// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-post-info{
    width: 100%;
    padding: 1.8em 2.4em;
    background-color: var(--white-smoke);
    border-top: 1px solid var(--line-color-light);
    border-bottom: 1px solid var(--line-color-light);
    display: flex;
    flex-direction: column;
    row-gap: 1em;
}

.container-post-info .input-form{
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
    column-gap: 1.4em;
}

.container-post-info .post-input{
    display: 94%;
    height: 4em;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    background-color: inherit;
    row-gap: 0.2em;
}

.container-post-info .add-button-form,
.container-post-info .send-button-form,
.container-post-info .close-button-form{
    width: 2%;
}

.container-post-info .post-input label{
    font-size: 0.85em;
    font-weight: normal;
    padding-left: 0.4em;
    color: var(--grey-light);
}

.container-post-info .post-input .post-input-field{
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
}

.container-post-info .post-input input,
.container-post-info .post-input select{
    outline: none;
    width: 100%;
    font-size: 0.9em;
    background-color: var(--white);
    border: 1px solid var(--line-color);
    padding: 0.6em 0.2em 0.6em 0.5em;
}

.container-post-info .post-input input[type="checkbox"]{
    width: 1em;
    margin-left: 1.2em;
}

.container-post-info .post-input select:hover{
    cursor: pointer;
}

.container-post-info .post-input input:focus,
.container-post-info .post-input select:focus,
.container-post-info .post-input input:valid,
.container-post-info .post-input select:valid{
    border-bottom: #673AB7 1px solid;
    transition: border-color ease-in-out .10s,box-shadow ease-in-out .10s;
}

.container-post-info .send-button-form,
.container-post-info .close-button-form{
    position: relative;
    top: 0.65em;
}

`, "",{"version":3,"sources":["webpack://./src/pages/settings/configuration/post/style.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,oBAAoB;IACpB,oCAAoC;IACpC,6CAA6C;IAC7C,gDAAgD;IAChD,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,uBAAuB;IACvB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;;;IAGI,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;;IAEI,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,8BAA8B;IAC9B,mCAAmC;IACnC,gCAAgC;AACpC;;AAEA;IACI,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;;;;IAII,gCAAgC;IAChC,qEAAqE;AACzE;;AAEA;;IAEI,kBAAkB;IAClB,WAAW;AACf","sourcesContent":[".container-post-info{\n    width: 100%;\n    padding: 1.8em 2.4em;\n    background-color: var(--white-smoke);\n    border-top: 1px solid var(--line-color-light);\n    border-bottom: 1px solid var(--line-color-light);\n    display: flex;\n    flex-direction: column;\n    row-gap: 1em;\n}\n\n.container-post-info .input-form{\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    flex-direction: row;\n    column-gap: 1.4em;\n}\n\n.container-post-info .post-input{\n    display: 94%;\n    height: 4em;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: flex-start;\n    background-color: inherit;\n    row-gap: 0.2em;\n}\n\n.container-post-info .add-button-form,\n.container-post-info .send-button-form,\n.container-post-info .close-button-form{\n    width: 2%;\n}\n\n.container-post-info .post-input label{\n    font-size: 0.85em;\n    font-weight: normal;\n    padding-left: 0.4em;\n    color: var(--grey-light);\n}\n\n.container-post-info .post-input .post-input-field{\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n}\n\n.container-post-info .post-input input,\n.container-post-info .post-input select{\n    outline: none;\n    width: 100%;\n    font-size: 0.9em;\n    background-color: var(--white);\n    border: 1px solid var(--line-color);\n    padding: 0.6em 0.2em 0.6em 0.5em;\n}\n\n.container-post-info .post-input input[type=\"checkbox\"]{\n    width: 1em;\n    margin-left: 1.2em;\n}\n\n.container-post-info .post-input select:hover{\n    cursor: pointer;\n}\n\n.container-post-info .post-input input:focus,\n.container-post-info .post-input select:focus,\n.container-post-info .post-input input:valid,\n.container-post-info .post-input select:valid{\n    border-bottom: #673AB7 1px solid;\n    transition: border-color ease-in-out .10s,box-shadow ease-in-out .10s;\n}\n\n.container-post-info .send-button-form,\n.container-post-info .close-button-form{\n    position: relative;\n    top: 0.65em;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
